import get from './get'
import getNowOptions from './getNowOptions'
import set from './set'
import setNowOptions from './setNowOptions'
import update from './update'

export default {
  ...get,
  ...getNowOptions,
  ...set,
  ...setNowOptions,
  ...update,
}
